export enum ProductId {
  EVR = "123a771c-e319-472f-846d-91828e0f5e09",
  TRACC = "124a771c-e319-472f-846d-91828e0f5e09",
  DATA_CUTTER = "113a771c-e319-472f-846d-91828e0f5e09",
  IDENTITY_PROVIDER = "133a771c-e319-472f-846d-91828e0f5e09",
}

export const productsLogoHeight: Record<string, string> = {
  Evr: "60%",
  Tracc: "45%",
};
